// extracted by mini-css-extract-plugin
export var buttonArrow = "ContactForm-module--button-arrow--3dd55";
export var checkbox = "ContactForm-module--checkbox--aa2a9";
export var checkboxLabel = "ContactForm-module--checkboxLabel--113bd";
export var checkboxLabelFooter = "ContactForm-module--checkboxLabelFooter--edcc1";
export var contactForm = "ContactForm-module--contact-form--2e7ca";
export var customLabel = "ContactForm-module--customLabel--fdba4";
export var footer = "ContactForm-module--footer--287cc";
export var formHeader = "ContactForm-module--formHeader--55242";
export var mainBody = "ContactForm-module--main-body--dd274";
export var requiredField = "ContactForm-module--requiredField--b57b9";
export var success = "ContactForm-module--success--62e4c";